import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Check, Users, CreditCard } from "lucide-react";

interface PurchaseChildProfileDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onPurchase: () => void;
}

export function PurchaseChildProfileDialog({
  open,
  onOpenChange,
  onPurchase,
}: PurchaseChildProfileDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-lg" data-testid="dialog-purchase-child-profile">
        <AlertDialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="bg-gradient-to-r from-purple-600 to-teal-600 p-3 rounded-full">
              <Users className="h-6 w-6 text-white" />
            </div>
            <AlertDialogTitle className="text-2xl" data-testid="text-purchase-title">
              Add Another Child
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-base space-y-4" data-testid="text-purchase-description">
            <div className="bg-gradient-to-r from-purple-50 to-teal-50 p-4 rounded-lg border border-purple-200">
              <div className="flex items-center justify-between mb-3">
                <span className="text-lg font-semibold text-gray-900">Additional Child Profile</span>
                <span className="text-2xl font-bold text-purple-600">$1.99</span>
              </div>
              <p className="text-sm text-gray-600 mb-3">One-time purchase • Unlimited stories</p>
              <div className="space-y-2">
                <div className="flex items-start gap-2 text-sm text-gray-700">
                  <Check className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                  <span>Personalized story preferences for each child</span>
                </div>
                <div className="flex items-start gap-2 text-sm text-gray-700">
                  <Check className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                  <span>Individual story libraries per child</span>
                </div>
                <div className="flex items-start gap-2 text-sm text-gray-700">
                  <Check className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                  <span>Age-appropriate content for each profile</span>
                </div>
                <div className="flex items-start gap-2 text-sm text-gray-700">
                  <Check className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                  <span>Custom narration settings per child</span>
                </div>
              </div>
            </div>
            
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
              <p className="text-sm text-blue-800">
                💡 <strong>Your first child profile is free!</strong> Additional profiles are just $1.99 each and never expire.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col sm:flex-row gap-2">
          <AlertDialogCancel className="mt-0" data-testid="button-cancel-purchase">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onPurchase}
            className="bg-gradient-to-r from-purple-600 to-teal-600 hover:from-purple-700 hover:to-teal-700 text-white"
            data-testid="button-confirm-purchase"
          >
            <CreditCard className="h-4 w-4 mr-2" />
            Continue to Purchase
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

